import styled from 'styled-components';
import { variableFontRegular } from 'styles/theme/text';

import { ICurrencyObject } from 'shared/types/BuyBarProductVariant';
import { LocalizedCurrency } from 'shared/components/LocalizedCurrency';
import { BuyBarItemDesktopNoStock } from 'productTemplate/components/buyBar/BuyBarItemDesktopNoStock';
import { OutOfStock } from 'productTemplate/components/buyBar/SwiperSlides/OutOfStock';
import { ISize } from 'shared/types/Size';
import { localizeSize } from 'productTemplate/enums/translation';

export interface ISizeAndPriceProps {
  sizeOption: ISize;
  lowestPriceCents: ICurrencyObject;
  isActive: boolean;
  isCurrentlyUnavailable: boolean;
  isActiveAndExpanded: boolean;
  isSpecial?: boolean;
}

export const SizeAndPrice = ({
  sizeOption,
  lowestPriceCents,
  isActive,
  isCurrentlyUnavailable,
  isActiveAndExpanded,
  isSpecial = false,
}: ISizeAndPriceProps) => {
  if (isCurrentlyUnavailable) return <BuyBarItemDesktopNoStock item={sizeOption} />;

  const renderPriceOrOOS = () => {
    if (lowestPriceCents !== undefined) {
      return (
        <SizeAndPrice.Price
          data-qa={`buy_bar_price_size_${sizeOption?.presentation}`}
          price={lowestPriceCents?.amount}
          roundDownToDollarAmount
        />
      );
    }

    return (
      <OutOfStock
        data-qa="buy_bar_out_of_stock"
        isActive={isActive}
        isCurrentlyUnavailable={isSpecial}
      />
    );
  };

  return (
    <SizeAndPrice.Root data-qa="buy_bar_item_desktop" $isActiveAndExpanded={isActiveAndExpanded}>
      <SizeAndPrice.Size data-qa={`buy_bar_size_${sizeOption?.presentation}`}>
        {localizeSize(sizeOption?.presentation)}
      </SizeAndPrice.Size>
      {renderPriceOrOOS()}
    </SizeAndPrice.Root>
  );
};

SizeAndPrice.Root = styled.div<{
  $isActiveAndExpanded: boolean;
}>`
  ${variableFontRegular({ height: '14px', size: '12px' })};
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding-top: 6px;
  padding-bottom: 24px;
  &:hover {
    cursor: pointer;
  }

  &:hover span {
    text-decoration: underline;
  }
  border-bottom: ${({ $isActiveAndExpanded }) =>
    $isActiveAndExpanded ? '3px solid #000;' : 'none;'};
`;

SizeAndPrice.Size = styled.div`
  margin-bottom: 4px;
  text-transform: uppercase;
`;

SizeAndPrice.Price = styled(LocalizedCurrency)`
  &:hover {
    text-decoration: underline;
  }
`;
